import mediator from '../utilities/mediator';
import log from '../utilities/log';
import { ApiErrorResponse } from '../models';
import { queryOptions, UseQueryOptions } from '@tanstack/react-query';

type AboutResponse = Record<string, unknown>;

export function systemAboutQueryOptions(
  options?: Partial<UseQueryOptions<AboutResponse>>,
) {
  return queryOptions<AboutResponse>({
    ...options,
    queryKey: ['system', 'about'],
    queryFn: async () => {
      try {
        return await mediator.request<AboutResponse>('system:getAbout');
      } catch (error: any) {
        log.error(error);
        throw new ApiErrorResponse(error.status, error.message);
      }
    },
  });
}
